document.addEventListener( 'DOMContentLoaded' , function () {

    let icons = document.querySelectorAll(".product-form .payment_method-list .list-payment__item");

    icons.forEach( icon => {
        icon.addEventListener( "click", function() {
            document.getElementsByClassName("shopify-payment-button__more-options")[0].click();
        });
    });

});

